import { createContext } from 'react';
import { AccountType } from '../types/AccountType';

export const AccountContext = createContext<AccountType | null>(null);
